export enum MailchimpMergeTagType {
  CARE_FNAME = 'care_fname',
  CARE_IMAGE = 'care_image',
}

export interface MailchimpMergeTag {
  key: MailchimpMergeTagType;
  value: string;
}
